import {
  Close,
  Content,
  Description,
  Overlay,
  Portal,
  Root,
  Title,
  Trigger
} from "../../../chunk-VXS6VZEN.mjs";
import "../../../chunk-YNII5Y6F.mjs";
import "../../../chunk-RRWBFD4V.mjs";
import "../../../chunk-HFXIPTW6.mjs";
import "../../../chunk-4U6MH43A.mjs";
import "../../../chunk-OPCIACWD.mjs";
import "../../../chunk-GYRZVAMU.mjs";
import "../../../chunk-QOCR4XUU.mjs";
import "../../../chunk-D6QHF2UO.mjs";
import "../../../chunk-7TMHQ6XO.mjs";
import "../../../chunk-BQ72SK4G.mjs";
import "../../../chunk-FBWCVJGC.mjs";
import "../../../chunk-CD4FQC4X.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/Sheet/Sheet.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var cx = (...parts) => parts.filter(Boolean).join(" ");
function Sheet(props) {
  return /* @__PURE__ */ jsx(Root, { ...props });
}
Sheet.displayName = "Sheet";
function SheetTrigger({ ref, ...props }) {
  return /* @__PURE__ */ jsx(Trigger, { ref, ...props });
}
SheetTrigger.displayName = "SheetTrigger";
function SheetClose({ ref, ...props }) {
  return /* @__PURE__ */ jsx(Close, { ref, ...props });
}
SheetClose.displayName = "SheetClose";
function SheetOverlay({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx(Overlay, { ref, className: cx("buyscout-sheet__overlay", className), ...props });
}
SheetOverlay.displayName = "SheetOverlay";
function SheetContent({
  ref,
  className,
  side = "end",
  container,
  children,
  ...props
}) {
  return /* @__PURE__ */ jsxs(Portal, { container: container ?? void 0, children: [
    /* @__PURE__ */ jsx(SheetOverlay, {}),
    /* @__PURE__ */ jsx(
      Content,
      {
        ref,
        className: cx("buyscout-sheet__content", `buyscout-sheet__content--${side}`, className),
        ...props,
        children
      }
    )
  ] });
}
SheetContent.displayName = "SheetContent";
function SheetTitle({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx(Title, { ref, className: cx("buyscout-sheet__title", className), ...props });
}
SheetTitle.displayName = "SheetTitle";
function SheetDescription({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx(Description, { ref, className: cx("buyscout-sheet__description", className), ...props });
}
SheetDescription.displayName = "SheetDescription";
export {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetOverlay,
  SheetTitle,
  SheetTrigger
};
//# sourceMappingURL=Sheet.mjs.map